export class Submenu{
	init(){
		$('.submenu').siblings('a').css('cursor', 'default').click(function(e) {
			e.preventDefault();
			if($(window).width() < 860){
				$(this).siblings('.submenu').toggleClass('open');
			}
		})
	}
}